import React, { useState } from "react";
import "./Footer.scss";
import Modal from "../Modal/Modal";
import { ReactComponent as Linkedin } from "../../assets/ico/lk.svg";
import { ReactComponent as Insta } from "../../assets/ico/insta.svg";
import { ReactComponent as Behance } from "../../assets/ico/behance.svg";

const Footer = () => {
  const [showLegalNotice, setShowLegalNotice] = useState(false);

  return (
    <>
      <footer className="wrapper footer">
        <div className="container">
          <p>Made with ♥︎ by Léo Frati</p>
          <div className="social">
            <a
              href="https://www.linkedin.com/in/leofrati/"
              target="_blank"
              rel="noreferrer"
              aria-label="LinkedIn"
            >
              <Linkedin />
            </a>
            <a
              href="https://www.instagram.com/oelfrt/"
              target="_blank"
              rel="noreferrer"
              aria-label="Instagram"
            >
              <Insta />
            </a>
            <a
              href="https://www.behance.net/lofrati2"
              target="_blank"
              rel="noreferrer"
              aria-label="Behance"
            >
              <Behance />
            </a>
          </div>
          <p>Folio ✦ 2026</p>
          <a
            className="legal-notice-link"
            href="/"
            onClick={(e) => {
              e.preventDefault();
              setShowLegalNotice(true);
            }}
          >
            Legal Notice
          </a>
        </div>
      </footer>

      <Modal
        isOpen={showLegalNotice}
        onClose={() => setShowLegalNotice(false)}
        title="Legal notice"
        size="large"
      >
        <div className="legal-notice">
          <h3>Publisher</h3>
          <p>
            This website is published by <strong>Léo FRATI</strong>,
            micro-entrepreneur (France).
          </p>
          <p>
            <strong>SIRET:</strong> 889 448 759 00015
            <br />
            <strong>VAT:</strong> not applicable
            <br />
            <strong>Location:</strong> Bordeaux, France
            <br />
            <strong>Contact:</strong> via the contact form
          </p>

          <h3>Hosting</h3>
          <p>This website is hosted by Vercel.</p>

          <h3>Privacy (summary)</h3>
          <p>
            If you use the contact form, the following data may be collected:
            name, email address, and message. Messages are sent via EmailJS for
            the sole purpose of replying to your request and are kept as long as
            necessary to reply.
          </p>
          <p>
            This website embeds Mapbox for the interactive map and uses Umami
            Analytics to measure audience.
          </p>

          <h3>Intellectual property</h3>
          <p>
            Unless otherwise stated, all content on this website (texts,
            visuals, and design) is the property of Léo FRATI. Any reproduction
            or reuse without prior permission is prohibited.
          </p>
        </div>
      </Modal>
    </>
  );
};

export default Footer;
